import React, { useEffect, useRef, useState } from 'react';
import { Switch, Route, Redirect, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import storage from 'shared/storage';
import { SignupProvider } from './context/SignupContext';
import StepOne from './SignupStepOne';
import StepTwo from './SignupStepTwo';

export const Logo = styled.img`
  width: 25px;
  height: 25px;
  margin: 5px;
  cursor: pointer;
  align-self: center;
`;

const PromoterSignup = () => {
  const history = useHistory();
  const [phoneNumber, setPhoneNumber] = useState('');
  const phoneInputRef = useRef();
  const [countryCode, setCountryCode] = useState('1');

  useEffect(() => {
    if (storage.get('promoter-user-phone')) {
      const phone = storage.get('promoter-user-phone');
      setPhoneNumber(String(phone.phone));
      setCountryCode(phone.calling_code);
    }
  }, []);

  return (
    <SignupProvider>
      <Switch>
        <Route exact path="/promoter-signup/phone">
          <StepOne
            setPhoneNumber={setPhoneNumber}
            phoneNumber={phoneNumber}
            phoneInputRef={phoneInputRef}
            countryCode={countryCode}
            setCountryCode={setCountryCode}
            setStep={(step) => {
              if (step === 'StepTwo') {
                history.push('/promoter-signup/verify');
              }
            }}
          />
        </Route>

        <Route exact path="/promoter-signup/verify">
          <StepTwo
            phoneNumber={phoneNumber}
            setPhoneNumber={setPhoneNumber}
            countryCode={countryCode}
            setStep={(step) => {
              if (step === 'CreateUser' || step === 'CreateAccount') {
                history.push('/promoter-signup/welcome');
              }
            }}
            setShowConfirmation={() => history.push('/promoter-signup/phone')}
          />
        </Route>

        {/* Default: Redirect to phone step */}
        <Redirect from="/promoter-signup" to="/promoter-signup/phone" />
      </Switch>
    </SignupProvider>
  );
};

export default PromoterSignup;
